import Passport from 'components/images/passport';
import Drivers from 'components/images/drivers';
import ID from 'components/images/id';

const CustomIcons = [
  {
    id: 'Passport',
    icon: Passport,
  },
  {
    id: 'Drivers',
    icon: Drivers,
  },
  {
    id: 'ID',
    icon: ID,
  },
];

export default CustomIcons;
